const CrosstabSortOption = Object.freeze({
  ALPHABETICALLY: 'ALPHABETICALLY',
  ROW_METRIC_ASC: 'ROW_METRIC_ASC',
  ROW_METRIC_DES: 'ROW_METRIC_DES',
  COLUMN_METRIC_ASC: 'COLUMN_METRIC_ASC',
  COLUMN_METRIC_DES: 'COLUMN_METRIC_DES',
  SELECTED_ORDER: 'SELECTED_ORDER'
})
export default CrosstabSortOption
export type CrosstabSortOptionStrings = typeof CrosstabSortOption[keyof typeof CrosstabSortOption]
// RESERVE BELOW
